import React, { FunctionComponent } from "react";
import { Box, Typography } from "@mui/material";
import { UserChip } from "../../UserChip";
import { ChangeLogList } from "../ChangeLogList";
import { Log, ChangeInformationCardProps } from "../types";

export const ChangeInformationCard: FunctionComponent<ChangeInformationCardProps> = (props) => {
    return (
        <Box width={500} height={400} borderRadius={2} border={"2px solid #F1F2F4"}>
        <Box borderBottom="2px solid #F1F2F4" p={2} >
            <Typography fontSize={14} fontWeight="600" color="#1BA0E9">{ props.label } Information</Typography>
        </Box>
        <Box mt={2} p={2}>
            <Box display="flex" alignItems="center" gap={2} >
                <Typography fontSize={14} fontWeight="600" color="#1BA0E9">Changed By:</Typography>
                { props.author && <UserChip name={props.author} /> }
            </Box>
            <Box mt={2} display="flex" alignItems="center" gap={2} >
                <Typography fontSize={14} fontWeight="600" color="#1BA0E9">Changed On:</Typography>
                { props.date && <Typography fontSize={14}>{props.date}</Typography> }
            </Box>
            <Box mt={2} display="flex" alignItems="flex-start" gap={2}>
                <Typography fontSize={14} fontWeight="600" color="#1BA0E9">Changes log:</Typography>
                <ChangeLogList onSelect={props.onSelectLog} items={props.logs} />
            </Box>
        </Box>
    </Box>
    )
}